// Small shared pieces: status badges, numbers, pills, sync dot
import { useEffect, useState } from '../core/react.js';
import { MONO, T, fmt } from '../core/theme.js';

export const ST = {
  'TBC': {
    bg: '#F0F3F6',
    color: '#4A5568',
    br: '#C4CDD6'
  },
  'Quoted': {
    bg: T.amberBg,
    color: T.amber,
    br: T.amberBr
  },
  'Confirmed': {
    bg: T.blueBg,
    color: T.blue,
    br: T.blueBr
  },
  'Contracted': {
    bg: T.greenBg,
    color: T.green,
    br: T.greenBr
  },
  'Invoiced': {
    bg: T.purpBg,
    color: T.purple,
    br: T.purpBr
  },
  'Paid': {
    bg: '#E2FAE8',
    color: '#0E5225',
    br: '#70C885'
  },
  'Cancelled': {
    bg: '#F5F5F5',
    color: '#999',
    br: '#CCC'
  }
};
export function Badge({
  s,
  tiny
}) {
  const st = ST[s] || ST['TBC'];
  return React.createElement("span", {
    style: {
      display: 'inline-block',
      fontSize: tiny ? 9 : 10,
      fontWeight: 600,
      padding: tiny ? '1px 5px' : '2px 7px',
      letterSpacing: '0.04em',
      background: st.bg,
      color: st.color,
      border: `1px solid ${st.br}`,
      borderRadius: 2,
      fontFamily: "'Open Sans',system-ui,sans-serif",
      whiteSpace: 'nowrap'
    }
  }, s);
}
export function Num({
  v,
  f,
  neg,
  pos,
  dim
}) {
  const color = neg && v < 0 ? T.red : pos && v > 0 ? T.green : dim ? T.mist : 'inherit';
  const display = f === 'gbp' ? fmt.gbp(v) : f === 'usd' ? fmt.usd(v) : f === 'pct' ? fmt.pct(v) : fmt.num(v, 2);
  return React.createElement("span", {
    style: {
      ...MONO,
      fontSize: 11,
      color
    }
  }, display);
}
export function Pill({
  label,
  color,
  bg
}) {
  return React.createElement("span", {
    style: {
      fontSize: 9,
      fontWeight: 700,
      letterSpacing: '0.1em',
      padding: '2px 8px',
      background: bg || 'rgba(62,63,67,0.08)',
      color: color || T.navy,
      borderRadius: 2
    }
  }, label);
}
export function SyncDot({
  synced,
  lastFetch
}) {
  const [, tick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => tick(n => n + 1), 5000);
    return () => clearInterval(id);
  }, []);
  const t = typeof lastFetch === 'number' ? new Date(lastFetch).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' }) : lastFetch;
  const label = !lastFetch ? 'Connecting…' : synced ? `Saved · ${t}` : 'Saving…';
  return React.createElement("span", {
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 5,
      fontSize: 10,
      color: 'rgba(255,255,255,0.65)'
    }
  }, React.createElement("span", {
    style: {
      width: 6,
      height: 6,
      borderRadius: '50%',
      background: !lastFetch ? T.mist : synced ? '#4ade80' : '#fbbf24',
      animation: !synced && lastFetch ? 'pulse 1.5s infinite' : undefined
    }
  }), label);
}
// the plain field and button looks most pages use
export const inputStyle = { padding: '8px 10px', border: `1px solid ${T.rule}`, background: T.white, fontSize: 13, color: T.coal, borderRadius: 0, fontFamily: 'inherit' };
export const btnStyle = primary => ({ padding: '9px 16px', background: primary ? T.navy : T.white, color: primary ? T.white : T.coal, border: `1px solid ${primary ? T.navy : T.rule}`, fontSize: 12, fontWeight: 600, cursor: 'pointer' });
